module.exports = __webpack_public_path__ + "img/13.1a4ff3c8.jpg";